let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("b8M9e")).then(() => parcelRequire('k1tgV'));